module.exports = __webpack_public_path__ + "static/media/14UNEP10.29efec94.jpg";